import { useParams } from 'react-router-dom';

import { FormStep, FormStepHeader } from './form/form-step';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { useJobProgress } from '@/hooks/useJobProgress';
import { FileUploader } from '@/new/components/file-uploader';

export function DocumentsStep({ setFilesProcessing }: { setFilesProcessing: (processing: boolean) => void }) {
  const { matterId } = useParams();
  if (!matterId) return null;

  const { data: matter } = useGetMatterV2(matterId);
  const allDocumentsCaseId = matter?.allDocumentsCaseId ?? null;
  const { activeJobs } = useJobProgress(allDocumentsCaseId ?? '');

  return (
    <FormStep className="h-full">
      <FormStepHeader
        title="Upload Documents"
        description="Upload documents to your matter, or create your matter now and upload documents later."
        icon="lucide--upload"
      />

      <FileUploader
        setFilesProcessing={setFilesProcessing}
        activeJobs={activeJobs}
        allDocumentsCaseId={allDocumentsCaseId}
        isMatterCreator
      />
    </FormStep>
  );
}
